import { EMPLOYEE_GENDER } from '@/modules/Employee/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Chip } from 'vnetwork-ui'

interface Props {
    employee_gender: string
}

const EmployeeGender: React.FC<Props> = ({ employee_gender }) => {
    const { t } = useTranslation()

    return (
        <Chip
            label={
                EMPLOYEE_GENDER(t).find(
                    (item) => item.value === employee_gender
                )?.label || ''
            }
            size="small"
            variant="contained"
            color={
                employee_gender === 'male'
                    ? 'success'
                    : employee_gender === 'female'
                      ? 'error'
                      : 'warning'
            }
        />
    )
}

export default EmployeeGender
